import { patientActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import _ from 'lodash';

const initialState = {
};

export const reducer = createReducer(initialState, {
    [patientActions.loadSuccess]: (state, action) => {
        return _.merge(state, action.payload.entities.fotoSurveys);
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        if (action.payload.patientsContainer.entities) {
            return { ...state, ...action.payload.patientsContainer.entities.fotoSurveys };
        } else {
            return state;
        }
    },
    [patientActions.closeSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if (x.ptno === action.payload) {
                delete state[x.id];
            }
        })
    },
    [patientActions.changeFotoClaimStatusSuccess]: (state, action) => {
        Object.values(state).forEach(x => {
            if (x.epno === action.payload.epno) {
                delete state[x.id];
            }
        })
        return _.merge(state, action.payload.response.entities.fotoSurveys);
    },
    [patientActions.loadFotoEpisodesSuccess]: (state, action) => {
        return { ...state, ...action.payload.entities.fotoSurveys };
    },
    [patientActions.refreshFotoEpisodesSuccess]: (state, action) => {
        return { ...state, ...action.payload.fotoRefresh.entities.fotoSurveys };
    },
    [patientActions.refreshFotoResponseSuccess]: (state, action) => {
        return { ...state, ...action.payload.entities.PTOUTMEASURES }
    },
    [patientActions.refreshFotoMessuresResponseSuccess]: (state, action) => {
        return { ...state, ...action.payload.fotoRefresh.entities.FOTOPATIENTRESPONSE }
    },

})


